import { useNavigate, useParams } from "react-router-dom";
import HeaderComponent from "../../../../components/header";
import ContainerComponent from "../../../../components/conatiner";
import InputComponent from "../../../../components/input";
import TableComponent from "../../../../components/table";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import LoadingComponent from "../../../../components/loading";
import { ApproversShowOrderService } from "../../../../services/approvers";
import { ToastErro, ToastSucesso } from "../../../../components/toast";
import moment from "moment";
import CardHeaderBackgroundComponent from "../../../../components/cardHeaderBackground";
import CardInfoComponent from "../../../../components/cardInfo";
import ModalComponent from "../../../../components/modal";
import { NumericFormat } from 'react-number-format';
import { TextField } from "@mui/material";
import { ApproversCreateAdvanceService } from "../../../../services/approvers/advances";
import { ApproversRDIApproveService, ApproversRDIReproveService } from "../../../../services/approvers/rdi";
import { urlMobile } from "../../../../services";
import OrderPDF from "../../../pdf/order";
import { isBusinessCard } from "../../../../components/businessCardBadge";

const ApproversInfoOrdersPage = () => {

    const navigate = useNavigate();

    const { id } = useParams();

    const [loading, setLoading] = useState<boolean>(true);

    const [isCheckAll, setIsCheckAll] = useState<boolean>(false);
    const [isCheck, setIsCheck] = useState<number[]>([]);

    const [visibleSpendinTypes, setVisibleSpendinTypes] = useState<boolean>(false);
    const [visibleAdvances, setVisibleAdvances] = useState<boolean>(false);

    const [itensToDisapproval, setItensToDisapproval] = useState<Array<any>>([]);

    const [permissionToApprove, setPermissionToApprove] = useState<boolean>(false);

    const [order, setOrder] = useState<any>(null);
    const [items, setItems] = useState<any>([]);
    const [advances, setAdvances] = useState<any>([]);
    const [spendingTypes, setSpendingTypes] = useState<any>([]);

    const [totalValue, setTotalValue] = useState<number>(0);
    const [totalAdvances, setTotalAdvances] = useState<number>(0);

    // variaveis para cadastrar adiantamento
    const [createDescription, setCreateDescription] = useState<string>('');
    const [createValue, setCreateValue] = useState<number>(null!);
    // variaveis para cadastrar adiantamento

    // função para pesquisar dados da ordem
    const getData = async () => {

        setLoading(true);

        await ApproversShowOrderService(parseInt(id!)).then(resp => {
            setOrder(resp.data.order);
            setItems(resp.data.items);
            setAdvances(resp.data.advances);
            setPermissionToApprove(resp.data.permissionToApprove);
            setSpendingTypes(resp.data.spendingTypes);

            // calcular valor total
            let calcTotal: number = 0;

            resp.data.items.map((i: any) => {
                if (i.status_id == 1 || i.status_id == 2 || i.status_id == 3 || i.status_id == 7) {
                    calcTotal += i.value;
                }
            });

            setTotalValue(calcTotal);
            // calcular valor total

            // calcular valor dos adiantamentos
            let calcAdvamces: number = 0;

            resp.data.advances.map((a: any) => {
                calcAdvamces += a.value;
            });

            setTotalAdvances(calcAdvamces);
            // calcular valor dos adiantamentos
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            navigate("/approvers/orders");
        });

        setLoading(false);

    }
    // função para pesquisar dados da ordem

    // função para cadastra adiantamentos
    const createAdvance = async (e: FormEvent<HTMLFormElement>) => {

        e.preventDefault();

        if (order.status_id != 3) {
            ToastErro("Não é possível cadastrar um adiantamento para esta ordem!");
            return;
        }

        (window as any).$("#modalCreateAdvamce").modal('hide');

        setLoading(true);

        await ApproversCreateAdvanceService(parseInt(id!), createDescription, createValue).then(resp => {
            ToastSucesso(resp.data.message);
            getData();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para cadastra adiantamentos

    // função para selecionar todas as check box
    const selectAll = (e: ChangeEvent<HTMLInputElement>) => {

        setIsCheckAll(e.target.checked);

        let arrayItems: number[] = [];

        items.map((i: any) => {
            arrayItems.push(i.id);
        });

        if (e.target.checked) {
            setIsCheck(arrayItems);
        } else {
            setIsCheck([]);
        }
    }
    // função para selecionar todas as check box

    const handleClick = (e: ChangeEvent<HTMLInputElement>) => {

        const index = isCheck.indexOf(parseInt(e.target.value)); // procura o index do item no array

        if (e.target.checked) // caso tenha sido checado
        {
            if (index < 0) // se não existir dentro do array
            {
                setIsCheck([...isCheck, parseInt(e.target.value)]); // adicionar dentro do array
            }
        } else // caso tenha sido desmarcado
        {
            let arrayItem: number[] = [...isCheck];

            arrayItem.splice(index, 1); // remover o index encontrado

            setIsCheck(arrayItem);
        }
    };

    // função para mostrar modal de reprovação
    const showReprove = () => {

        let arrayItens: Array<any> = [];

        isCheck.map((i: number) => {
            arrayItens.push({
                id: i,
                reason: ''
            });
        })

        setItensToDisapproval(arrayItens);

        (window as any).$("#modalReprovar").modal("show");

    }
    // função para mostrar modal de reprovação

    // função para aprovar rdi
    const approve = async () => {


        if (isCheck.length < 1) {
            ToastErro('Selecione no mínimo 1 item para aprovar!');
            return;
        }

        (window as any).$("#modalAprovar").modal("hide");

        setLoading(true);

        await ApproversRDIApproveService(parseInt(id!), JSON.stringify(isCheck)).then(resp => {
            ToastSucesso(resp.data.message);
            setIsCheck([]);
            setIsCheckAll(false);
            getData();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            getData();
        });

    }
    // função para aprovar rdi

    // função para reprovar rdi
    const reprove = async (e: FormEvent<HTMLFormElement>) => {

        e.preventDefault();

        if (isCheck.length < 1) {
            ToastErro('Selecione no mínimo 1 item para reprovar!');
            return;
        }

        (window as any).$("#modalReprovar").modal("hide");

        setLoading(true);

        await ApproversRDIReproveService(parseInt(id!), JSON.stringify(itensToDisapproval)).then(resp => {
            ToastSucesso(resp.data.message);
            setIsCheck([]);
            setItensToDisapproval([]);
            setIsCheckAll(false);
            getData();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
            return;
        });

    }
    // função para reprovar rdi

    // função para alterar motivo
    const changeReason = (index: number, value: string) => {

        let arrayItens: Array<any> = [...itensToDisapproval];

        arrayItens[index].reason = value;

        setItensToDisapproval(arrayItens);

    }
    // função para alterar motivo

    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            <HeaderComponent
                title={`Informações da Ordem Nº ${id}`}
                iconButton="arrow_back"
                button="Voltar"
                onClick={() => navigate(-1)}
                button3={order?.status_id == 3 ? "Adiantamento" : ""}
                iconButton3="add"
                onClick3={() => (window as any).$("#modalCreateAdvamce").modal('show')}
                onClick2={() => OrderPDF(parseInt(id!), order, items, advances, spendingTypes, totalValue, totalAdvances)}
                iconButton2="download"
                button2="PDF"
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Informações"
                    >
                        {
                            loading

                                ?

                                <LoadingComponent />

                                :

                                <>
                                    <div className="row">
                                        <InputComponent
                                            label="Data de Cadastro"
                                            col={3}
                                            defaultValue={moment(order?.created_at).format('DD/MM/YYYY')}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Status"
                                            col={3}
                                            defaultValue={order?.status}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Nível Atual de Aprovação"
                                            col={3}
                                            defaultValue={order?.level}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Quantidade de Níveis de Aprovação"
                                            col={3}
                                            defaultValue={order?.approval_levels}
                                            disabled
                                            size={"small"}
                                        />
                                    </div>
                                    <div className="row">
                                        <InputComponent
                                            label="Centro de Custo"
                                            col={6}
                                            defaultValue={order?.cost_center}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Usuário"
                                            col={6}
                                            defaultValue={order?.name}
                                            disabled
                                            size={"small"}
                                        />
                                    </div>
                                    <div className="row">
                                        <InputComponent
                                            label="Cartão Corporativo"
                                            col={3}
                                            defaultValue={isBusinessCard(order?.payment_business_card) ? 'Sim' : 'Não'}
                                            disabled
                                            size={"small"}
                                        />
                                    </div>
                                    <div className="row">
                                        <InputComponent
                                            label="CPF"
                                            col={3}
                                            defaultValue={order?.cpf}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Banco"
                                            col={3}
                                            defaultValue={order?.bank}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Agência"
                                            col={3}
                                            defaultValue={order?.agency}
                                            disabled
                                            size={"small"}
                                        />
                                        <InputComponent
                                            label="Conta"
                                            col={3}
                                            defaultValue={order?.account}
                                            disabled
                                            size={"small"}
                                        />
                                    </div>
                                </>
                        }
                    </CardHeaderBackgroundComponent>

                    <div className="row gx-5">
                        <CardInfoComponent
                            title="Valor Total"
                            subtitle={totalValue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            col={4}
                            icon="payments"
                        />
                        <CardInfoComponent
                            title="Total de Adiantamentos"
                            subtitle={totalAdvances.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            col={4}
                            icon="payments"
                        />
                        <CardInfoComponent
                            title="Valor Restante"
                            subtitle={(totalValue - totalAdvances).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            col={4}
                            icon="payments"
                        />
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <TableComponent
                                title="Adiantamentos"
                                columns={['ID', 'Descrição', 'Valor', 'Responsável']}
                                loading={loading}
                                iconButton={visibleAdvances ? 'expand_less' : 'expand_more'}
                                button={visibleAdvances ? 'Ocultar' : 'Expandir'}
                                onClick={() => setVisibleAdvances(!visibleAdvances)}
                            >
                                {

                                    visibleAdvances &&

                                    advances.map((a: any) => {
                                        return (
                                            <tr key={a.id}>
                                                <td className="px-4">{a.id}</td>
                                                <td className="px-4">{a.description}</td>
                                                <td className="px-4">{parseFloat(a.value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                                <td className="px-4">{a.name}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </TableComponent>
                        </div>
                        <div className="col-md-6">
                            <TableComponent
                                title="Gatos por Categoria"
                                columns={['Categoria', 'Valor']}
                                loading={loading}
                                iconButton={visibleSpendinTypes ? 'expand_less' : 'expand_more'}
                                button={visibleSpendinTypes ? 'Ocultar' : 'Expandir'}
                                onClick={() => setVisibleSpendinTypes(!visibleSpendinTypes)}
                            >
                                {

                                    visibleSpendinTypes &&

                                    spendingTypes.map((s: any) => {
                                        return (
                                            <tr key={s.id}>
                                                <td className="px-4">{s.type}</td>
                                                <td className="px-4">{parseFloat(s.value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </TableComponent>
                        </div>
                    </div>

                    <TableComponent
                        title="Itens da Ordem"
                        columns={permissionToApprove && order?.status_id == 3 ? [<input type="checkbox" className="selectAllItems" onChange={selectAll} defaultChecked={isCheckAll} />, 'Nº do Item', 'Categoria', 'Status', 'Data', 'Valor', 'Estado', 'Cidade', 'Modelo', 'Placa', 'Qtd.', 'Arquivo', 'Informações'] : ['Nº do Item', 'Categoria', 'Status', 'Data', 'Valor', 'Estado', 'Cidade', 'Modelo', 'Placa', 'Qtd.', 'Arquivo', 'Informações']}
                        loading={loading}
                        button={isCheck.length > 0 ? "Aprovar" : ''}
                        iconButton={"add"}
                        button2={isCheck.length > 0 ? "Reprovar" : ''}
                        iconButton2={"remove"}
                        onClick={() => (window as any).$("#modalAprovar").modal("show")}
                        onClick2={showReprove}
                    >
                        {
                            items.map((i: any) => {
                                return (
                                    <tr key={i.id}>
                                        {
                                            permissionToApprove && order?.status_id == 3 &&

                                            <td className="px-4">
                                                <input type="checkbox" className="checkItem" value={i.id} checked={isCheck.includes(parseInt(i.id))} onChange={(e: ChangeEvent<HTMLInputElement>) => handleClick(e)} />
                                            </td>
                                        }
                                        <td className="px-4">{i.id}</td>
                                        <td className="px-4">{i.type}</td>
                                        <td className="px-4">
                                            {
                                                i.status == 'Aprovado'

                                                    ?

                                                    <h6><span className="badge bg-info">{i.status}</span></h6>

                                                    :

                                                    i.status == 'Pago'

                                                        ?

                                                        <h6><span className="badge bg-success">{i.status}</span></h6>

                                                        :

                                                        i.status == 'Pendente de Aprovação'

                                                            ?

                                                            <h6><span className="badge bg-warning">{i.status}</span></h6>

                                                            :

                                                            i.status == 'Pendente de Aprovação'

                                                                ?

                                                                <h6><span className="badge bg-warning">{i.status}</span></h6>

                                                                :

                                                                i.status == 'Aprovado'

                                                                    ?

                                                                    <h6><span className="badge bg-primary">{i.status}</span></h6>

                                                                    :

                                                                    <h6><span className="badge bg-danger">{i.status}</span></h6>
                                            }
                                        </td>
                                        <td className="px-4">{moment(i.date).format('DD/MM/YYYY')}</td>
                                        <td className="px-4">{parseFloat(i.value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                        <td className="px-4">{i.uf}</td>
                                        <td className="px-4">{i.city}</td>
                                        <td className="px-4">{i.vehicle_model}</td>
                                        <td className="px-4">{i.license_plate}</td>
                                        <td className="px-4">{i.amount}</td>
                                        <td className="px-4">
                                            <button className="btn btn-text-primary" type="button" title="Visualizar Arquivo" onClick={() => {
                                                (window as any).open(urlMobile.replaceAll('api/', 'storage') + i.file, '_blank').focus();
                                            }}>
                                                <i className="material-icons">description</i>
                                            </button>
                                        </td>
                                        <td className="px-4">
                                            <button className="btn btn-text-info" type="button" title="Informações" onClick={() => (window as any).$("#modalInfo" + i.id).modal('show')}><i className="material-icons">info</i></button>
                                            <ModalComponent
                                                title="Informações do Item"
                                                id={`modalInfo${i.id}`}
                                                big
                                            >
                                                <>
                                                    <div className="row mt-4">
                                                        <InputComponent
                                                            label="Nº do Item"
                                                            col={4}
                                                            defaultValue={i.id}
                                                            disabled
                                                        />
                                                        <InputComponent
                                                            label="Categoria"
                                                            col={4}
                                                            defaultValue={i.type}
                                                            disabled
                                                        />
                                                        <InputComponent
                                                            label="Status"
                                                            col={4}
                                                            defaultValue={i.status}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="row">
                                                        <InputComponent
                                                            label="Descrição"
                                                            col={12}
                                                            defaultValue={i.rdi_description}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="row">
                                                        <InputComponent
                                                            label="Data"
                                                            col={6}
                                                            defaultValue={moment(i.date).format("DD/MM/YYYY")}
                                                            disabled
                                                        />
                                                        <InputComponent
                                                            label="Valor"
                                                            col={6}
                                                            defaultValue={parseFloat(i.value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="row">
                                                        <InputComponent
                                                            label="Estado"
                                                            col={6}
                                                            defaultValue={i.uf}
                                                            disabled
                                                        />
                                                        <InputComponent
                                                            label="Cidade"
                                                            col={6}
                                                            defaultValue={i.city}
                                                            disabled
                                                        />
                                                    </div>
                                                    {
                                                        parseInt(i.type_id) == 1 || parseInt(i.type_id) == 5

                                                            ?

                                                            <>
                                                                <div className="row">
                                                                    <InputComponent
                                                                        label="Modelo"
                                                                        col={4}
                                                                        defaultValue={i.vehicle_model}
                                                                        disabled
                                                                    />
                                                                    <InputComponent
                                                                        label="Placa"
                                                                        col={4}
                                                                        defaultValue={i.license_plate}
                                                                        disabled
                                                                    />
                                                                    <InputComponent
                                                                        label="Quilometragem"
                                                                        col={4}
                                                                        defaultValue={i.mileage}
                                                                        disabled
                                                                    />
                                                                </div>
                                                                <div className="row">
                                                                    <InputComponent
                                                                        label="Quantidade"
                                                                        col={i.type_id == 1 ? 4 : 12}
                                                                        defaultValue={i.amount}
                                                                        disabled
                                                                    />
                                                                    {
                                                                        i.type_id == 1 &&

                                                                        <>
                                                                            <InputComponent
                                                                                label="Valor por Litro"
                                                                                col={4}
                                                                                defaultValue={(i.value / i.amount).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                                                                disabled
                                                                            />
                                                                            <InputComponent
                                                                                label="Tipo de Combustível"
                                                                                col={4}
                                                                                defaultValue={i.type_fuel}
                                                                                disabled
                                                                            />
                                                                        </>
                                                                    }
                                                                </div>
                                                            </>

                                                            :

                                                            <>
                                                            </>
                                                    }
                                                </>
                                            </ModalComponent>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>

                    <ModalComponent
                        title="Adicionar Adiantamento"
                        id="modalCreateAdvamce"
                    >
                        <form onSubmit={createAdvance}>
                            <div className="row mt-4">
                                <InputComponent
                                    label="Descrição"
                                    col={12}
                                    defaultValue={createDescription}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCreateDescription(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <NumericFormat
                                        customInput={TextField}
                                        prefix={'R$'}
                                        decimalScale={2}
                                        allowNegative={false}
                                        decimalSeparator=","
                                        thousandSeparator="."
                                        className="w-100"
                                        fixedDecimalScale
                                        label="Valor"
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                            setCreateValue(parseFloat(e.target.value.replace(/[^0-9,-]+/g, "").replace(",", ".")));
                                        }}
                                        defaultValue={createValue}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="submit">Adicionar</button>
                            </div>
                        </form>
                    </ModalComponent>

                    <ModalComponent
                        title="Aprovar Itens"
                        id="modalAprovar"
                    >
                        <>
                            <p>Você tem certeza que deseja aprovar os itens abaixo?</p>
                            <table className="table mt-4">
                                <tbody>
                                    {
                                        isCheck.map((s: number) => {
                                            return (
                                                <tr key={s}>
                                                    <td>N° do Item:</td>
                                                    <td>{s}</td>
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </table>
                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="button" onClick={approve}>Aprovar</button>
                            </div>
                        </>
                    </ModalComponent>

                    <ModalComponent
                        title="Reprovar Itens"
                        id="modalReprovar"
                    >
                        <form onSubmit={reprove}>
                            {
                                itensToDisapproval.map((s: any, index: number) => {
                                    return (
                                        <div className={`row ${index == 0 && 'mt-4'}`} key={s.id}>
                                            <InputComponent
                                                label={`Motivo da Reprovação do Item Nº ${s.id}`}
                                                col={12}
                                                defaultValue={s.reason}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => changeReason(index, e.target.value)}
                                                required
                                            />
                                        </div>
                                    );
                                })
                            }
                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="submit">Reprovar</button>
                            </div>
                        </form>
                    </ModalComponent>
                </>
            </ContainerComponent>
        </>
    );

}

export default ApproversInfoOrdersPage;